import React, { useContext, useEffect, useState } from 'react';
import { styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CardComponent } from '../CardComponent';
import { getStatisticsData } from '../../services/cloudFirestore';
import { Paniers } from '../../models/Paniers';
import { IndicatorViewModel } from '../../models/IndicatorsViewModal';
import { StyledColumnBox, StyledMediumTypography, StyledRowBox } from '../../theme/StyledElements';
import { EmojiCard } from '../EmojiCard';
import { useMountedRef } from '../../hooks/useMountedRef';
import { UserContext } from '../../providers/UserProvider';

const StyledIndicatorBox = styled(StyledColumnBox)(() => ({
    marginTop: '10px',
    textAlign: 'center'
}));

interface IndicatorProps {
    paniersList: Paniers[];
}

export function Indicators({ paniersList }: IndicatorProps): React.ReactElement {
    const { t } = useTranslation();
    const mounted = useMountedRef();
    const user = useContext(UserContext);
    const [indicatorData, setIndicatorData] = useState<IndicatorViewModel>({
        basketSold: 0,
        clients: 0,
        review: { dislikedPercentage: 0, neutralPercentage: 0, likedPercentage: 0 },
        turnOver: 0
    });

    useEffect(() => {
        if (user && user.idProducteur && mounted.current) {
            getStatisticsData(user.idProducteur).then((data) => {
                if (data && mounted.current) {
                    setIndicatorData(data);
                }
            });
        }
    }, [paniersList]);

    const basketsSold = (
        <StyledIndicatorBox>
            <StyledMediumTypography variant="h1" color="#134C03">
                {indicatorData?.basketSold}
            </StyledMediumTypography>
            <Typography variant="subtitle2" color="#134C03">
                {t('basketsSold')}
            </Typography>
        </StyledIndicatorBox>
    );

    const clients = (
        <StyledIndicatorBox>
            <StyledMediumTypography variant="h1" color="#134C03">
                {indicatorData?.clients}
            </StyledMediumTypography>
            <Typography variant="subtitle2" color="#134C03">
                {t('clients')}
            </Typography>
        </StyledIndicatorBox>
    );

    const turnOver = (
        <StyledIndicatorBox>
            <StyledMediumTypography variant="h1" color="#134C03">
                {indicatorData?.turnOver.toFixed(2)}€
            </StyledMediumTypography>
            <Typography variant="subtitle2" color="#134C03">
                {t('turnOver')}
            </Typography>
        </StyledIndicatorBox>
    );

    return (
        <StyledRowBox>
            <CardComponent>{basketsSold}</CardComponent>
            <CardComponent>{clients}</CardComponent>
            <CardComponent>{turnOver}</CardComponent>
            <CardComponent>
                <EmojiCard review={indicatorData.review} />
            </CardComponent>
        </StyledRowBox>
    );
}
